import _ from 'lodash';
import {
  spaceGroupShortNames,
  spaceGroupLongNames
} from '../../constants/SpaceGroups';


export function rank(results) {
    
    var anomalous = _.filter(results, function(o) { return (o.v_datacollection_summary_phasing_anomalous && (o.v_datacollection_processingStatus === "SUCCESS" || (o.v_datacollection_processingStatus === 1 || (o.v_datacollection_processingStatus === "1"))))});    
    var nonanomalous = _.filter(results, function(o) { return (o.v_datacollection_summary_phasing_anomalous === false && (o.v_datacollection_processingStatus === "SUCCESS" || (o.v_datacollection_processingStatus === 1 || (o.v_datacollection_processingStatus === "1"))))});
    var running = _.filter(results, function(o) { return o.v_datacollection_processingStatus === "RUNNING";});
    var failed = _.filter(results, function(o) { return o.v_datacollection_processingStatus === "FAILED" || (o.v_datacollection_processingStatus === 0 ); });
   

    var anomalousdata = sort(anomalous, "v_datacollection_summary_phasing_autoproc_space_group");    
    var nonanomalousdata = sort(nonanomalous, "v_datacollection_summary_phasing_autoproc_space_group");    
    
    return _.concat(nonanomalousdata, anomalousdata, running,failed);
}

function sort(array, spacegroudFieldName){
   /** First sorting autoprocessing with rMerge < 10 */
   var minus10Rmerge  = _.filter(array, function(o) {       
            if (o.innerShell){
                if (o.innerShell.rMerge){                    
                    if ((Number(o.innerShell.rMerge) <= 10) && (Number(o.innerShell.rMerge) > 0)){
                        return true;
                    }
                }
            }
            return false        
     }); 

    /** Second we get rMerge > 10 */
    var plus10Rmerge  = _.filter(array, function(o) {
        
            if (o.innerShell){
                if (o.innerShell.rMerge){                    
                    if (Number(o.innerShell.rMerge) > 10 || Number(o.innerShell.rMerge) <= 0){
                        return true;
                    }
                }
            }
            return false        
     }); 


    function sortByHighestSymmetry(a, b) {        
        var spaceGroupA = a[spacegroudFieldName].replace(/\s/g, "");
        var spaceGroupB = b[spacegroudFieldName].replace(/\s/g, "");

        var indexOfSpaceGroupA = _.indexOf(spaceGroupShortNames, spaceGroupA)
        if (indexOfSpaceGroupA === -1) {
            /** If not found check with long name */
            indexOfSpaceGroupA = _.indexOf(spaceGroupLongNames, spaceGroupA)
        }

        var indexOfSpaceGroupB = _.indexOf(spaceGroupShortNames, spaceGroupB)
        if (indexOfSpaceGroupB === -1) {
            indexOfSpaceGroupB = _.indexOf(spaceGroupLongNames, spaceGroupB)
        }

        if ( indexOfSpaceGroupA === indexOfSpaceGroupB ){
            return ( parseFloat(a.innerShell.rMerge) -  parseFloat(b.innerShell.rMerge));
        }
        return indexOfSpaceGroupB - indexOfSpaceGroupA;

    }
    
    function sortByrMerge(a, b) {                                    
         return ( parseFloat(a.innerShell.rMerge) -  parseFloat(b.innerShell.rMerge));                                       
    }



    minus10Rmerge.sort(sortByHighestSymmetry); 
    plus10Rmerge.sort(sortByrMerge); 

     /** Setting lables */
    if (plus10Rmerge){
        for(var i = 0; i < plus10Rmerge.length; i++){
            plus10Rmerge[i].label = "rMerge > 10";
        }
    }
       
    return _.concat(minus10Rmerge, plus10Rmerge);  
}



// WEBPACK FOOTER //
// ./src/helpers/Mx/AutoprocessingRank.js